"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var BidAccepted_1 = __importDefault(require("../../../Icons/Notifications/BidAccepted"));
var schemas_1 = require("@dcl/schemas");
var utils_1 = require("../../utils");
var Mana_1 = require("../../../Mana/Mana");
var NotificationItemNFTLink_1 = __importDefault(require("../../NotificationItemNFTLink"));
var i18N = {
    en: {
        description: function (mana, nftName) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Your offer of ",
            mana,
            " was accepted for ",
            nftName)); },
        title: 'Offer Accepted'
    },
    es: {
        description: function (mana, nftName) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Tu oferta de ",
            mana,
            " fue aceptada para ",
            nftName)); },
        title: 'Oferta aceptada'
    },
    zh: {
        description: function (mana, nftName) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "\u60A8\u7684\u51FA\u4EF7 ",
            mana,
            " \u5DF2\u88AB\u63A5\u53D7 ",
            nftName)); },
        title: '接受报价'
    }
};
/**
 * @deprecated Should start using the same component migrated to UI2.
 */
var BidAcceptedNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: {
            image: notification.metadata.image,
            backgroundColor: (0, utils_1.getBGColorByRarity)(notification.metadata.rarity),
            icon: react_1.default.createElement(BidAccepted_1.default, null)
        }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(react_1.default.createElement(Mana_1.Mana, { inline: true, network: notification.metadata.network === 'polygon'
                ? schemas_1.Network.MATIC
                : schemas_1.Network.ETHEREUM }, (0, utils_1.formatMana)(notification.metadata.price)), react_1.default.createElement(NotificationItemNFTLink_1.default, { name: notification.metadata.nftName, rarity: notification.metadata.rarity, link: notification.metadata.link })))));
};
exports.default = BidAcceptedNotification;
